import apiClient from './client';
import type {
  FloatRechargeRequest,
  CreateRechargePayload,
  CreateRechargeResponse,
  RechargeStatus,
  AdminRechargeListResponse,
  ApproveRechargeResponse,
  RejectRechargeResponse,
  DirectRechargePayload,
  DirectRechargeResponse,
} from '../types/float-recharge.types';

// ─── Agent endpoints ─────────────────────────────────────────────────────────

export const floatRechargeApi = {
  /** POST /agent/me/float/recharge-request */
  requestRecharge: async (
    payload: CreateRechargePayload
  ): Promise<CreateRechargeResponse> => {
    const { data } = await apiClient.post(
      '/agent/me/float/recharge-request',
      payload
    );
    return data;
  },

  /** GET /agent/me/float/recharge-requests */
  getMyRequests: async (
    status?: RechargeStatus,
    limit = 20
  ): Promise<FloatRechargeRequest[]> => {
    const params: Record<string, string | number> = { limit };
    if (status) params.status = status;
    const { data } = await apiClient.get(
      '/agent/me/float/recharge-requests',
      { params }
    );
    return Array.isArray(data) ? data : (data?.data ?? []);
  },

  // ─── Admin endpoints ──────────────────────────────────────────────────────

  /** GET /admin/agents/float/recharge-requests */
  adminListRequests: async (params?: {
    status?: RechargeStatus;
    agentId?: string;
    page?: number;
    limit?: number;
  }): Promise<AdminRechargeListResponse> => {
    const { data } = await apiClient.get(
      '/admin/agents/float/recharge-requests',
      { params }
    );
    return data;
  },

  /** POST /admin/agents/float/recharge-requests/:requestId/approve */
  adminApprove: async (
    requestId: string
  ): Promise<ApproveRechargeResponse> => {
    const { data } = await apiClient.post(
      `/admin/agents/float/recharge-requests/${requestId}/approve`,
      {}
    );
    return data;
  },

  /** POST /admin/agents/float/recharge-requests/:requestId/reject */
  adminReject: async (
    requestId: string,
    reason: string
  ): Promise<RejectRechargeResponse> => {
    const { data } = await apiClient.post(
      `/admin/agents/float/recharge-requests/${requestId}/reject`,
      { reason }
    );
    return data;
  },

  /** POST /admin/agents/:agentId/replenish-float (recarga directa) */
  adminDirectRecharge: async (
    agentId: string,
    payload: DirectRechargePayload
  ): Promise<DirectRechargeResponse> => {
    const { data } = await apiClient.post(
      `/admin/agents/${agentId}/replenish-float`,
      payload
    );
    return data;
  },
};
